import {constInitialState, constInitialStateRequest, constInvalid, constSend, constValid} from './../../../constants'
import {images_request_invalid, images_request_send, images_request_valid} from "../actions/images";
import {images_store_request_invalid, images_store_request_send, images_store_request_valid} from "../actions/store";
import {images_destroy_request_invalid, images_destroy_request_send, images_destroy_request_valid} from "../actions/destroy";
import _ from "underscore";

const initialState = {
    ...constInitialState(),
    storeData: {
        ...constInitialStateRequest()
    },
    destroyData: {
        ...constInitialStateRequest()
    },
};

export const imagesReducer = function (state = initialState, action) {
    switch (action.type) {
        case images_request_invalid: {
            return {
                ...state,
                ...constInvalid()
            };
        }
        case images_request_send: {
            return {
                ...state,
                ...constSend()
            };
        }
        case images_request_valid: {
            return {
                ...state,
                ...constValid(),
                response: {
                    ...state.response,
                    ...action.data
                }
            };
        }
        case images_store_request_invalid: {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    ...constInvalid()
                }
            };
        }
        case images_store_request_send: {
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    ...constSend()
                }
            };
        }
        case images_store_request_valid: {
            if (action.data.image_new) {
                let images = [...(state.response.images || [])];
                images.unshift(action.data.image_new);
                return {
                    ...state,
                    storeData: {
                        ...state.storeData,
                        ...constValid()
                    },
                    response: {
                        ...state.response,
                        images: images
                    }
                }
            }
            return {
                ...state,
                storeData: {
                    ...state.storeData,
                    ...constValid()
                }
            };
        }
        case images_destroy_request_invalid: {
            return {
                ...state,
                destroyData: {
                    ...state.destroyData,
                    ...constInvalid()
                }
            };
        }
        case images_destroy_request_send: {
            return {
                ...state,
                destroyData: {
                    ...state.destroyData,
                    ...constSend()
                }
            };
        }
        case images_destroy_request_valid: {
            if (action.data.image_destroy) {
                let images = _.filter(state.response.images || [], (image) => image.uuid !== action.data.image_destroy.uuid);
                return {
                    ...state,
                    destroyData: {
                        ...state.destroyData,
                        ...constValid()
                    },
                    response: {
                        ...state.response,
                        images: images
                    }
                }
            }
            return {
                ...state,
                destroyData: {
                    ...state.destroyData,
                    ...constValid()
                }
            };
        }
        default:
            return state;
    }
};